import React, { useCallback, useState } from 'react';
import cm from 'classnames';
import { Popover } from 'ksnm-common-ui/lib/Popover';
import type { ReactElement } from 'react';

import styles from './ButtonPopover.module.scss';

interface ButtonPopoverInterface {
  items?: { name: string; onClick: () => void; disabled?: boolean; title?: string }[];
  children: ReactElement;
}

export const ButtonPopover = ({ items = [], children }: ButtonPopoverInterface): ReactElement => {
  const [visiblePopover, setVisiblePopover] = useState(false);

  const handleClick = useCallback((event) => {
    event();
    setVisiblePopover(false);
  }, []);

  const handleVisibleChange = useCallback((visible) => {
    setVisiblePopover(visible);
  }, []);

  return (
    <Popover
      overlayClassName={styles.popover}
      placement="bottom"
      content={
        <div className={styles.content}>
          {items?.map((el) => (
            <div
              title={el.title}
              key={el.name}
              onClick={() => handleClick(el.onClick)}
              className={cm(styles.item, { [styles.disabled]: el.disabled })}
            >
              {el.name}
            </div>
          ))}
        </div>
      }
      trigger="click"
      open={visiblePopover}
      onOpenChange={handleVisibleChange}
    >
      {children}
    </Popover>
  );
};
